import fs from 'node:fs'
import { REMOVED_SCOPE } from '@cli-constants/snapshots.js'
import { snapshotRoot } from './snapshot-root.js'

export function listSnapshotScopes(cwd: string): string[] {
  const dir = snapshotRoot(cwd)
  if (!fs.existsSync(dir)) {
    return []
  }

  return fs
    .readdirSync(dir, { withFileTypes: true })
    .filter((entry) => entry.isDirectory())
    .map((entry) => entry.name)
    .filter((name) => name !== REMOVED_SCOPE)
    .sort()
}
